import { useCallback } from 'react';
import useVibeModeStore from '@/modules/VibeMode/VibeMode.store';
import { getVibeModeDockChannel } from '@/modules/VibeMode/vibe-mode-dock.contract';
import type { VibeModeDockCommand } from '@/modules/VibeMode/vibe-mode-dock.contract';

export const useVibeModeDockCommand = () => {
    const requestRetry = useVibeModeStore((state) => state.requestRetry);

    return useCallback(
        (command: VibeModeDockCommand) => {
            getVibeModeDockChannel().emitCommand(command);
            requestRetry();
        },
        [requestRetry]
    );
};
